import { useEffect, useState } from "react";

type UseIsScrolledOptions = {
  threshold?: number;
  isMobile?: boolean;
};

export const useIsScrolled = (
  options?: UseIsScrolledOptions
): boolean => {
  // threshold:How far from the top of the page to trigger the slim header
  const { threshold = 100, isMobile = false } = options || {};
  const [isScrolled, setIsScrolled] = useState<boolean>(false);

  useEffect(() => {
    const handleScroll = (): void => {
      if (isMobile) {
        setIsScrolled(false);
        return;
      }

      const scrollableHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const minimumScrollableContent = 300;

      // Hysteresis: different thresholds for up vs down
      const scrollY = window.scrollY;
      const exitThreshold = threshold * 0.5;

      setIsScrolled((prev) => {
        if (prev && scrollY <= exitThreshold) return false;
        if (!prev && scrollableHeight < minimumScrollableContent) return false;
        if (!prev && scrollY > threshold) return true;
        return prev;
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [threshold, isMobile]);

  return isScrolled;
};
